import { CpMovementResponseInterface } from '../../../interfaces/response/movement/cp-movement-response-interface';
import { CpMovementModel } from '../../dto/movement/cp-movement-model';
import { PaginationModel } from '@fh-client-interaction-frontends/fh-providers';

export class CpMovementResponseModel implements CpMovementResponseInterface {
  Claims: CpMovementModel[] = new Array<CpMovementModel>();
  PaginationResult: PaginationModel = new PaginationModel();

  constructor(init?: Partial<CpMovementResponseModel>) {
    Object.assign(this, init);
  }
}
